export default __webpack_public_path__ + "static/media/05.83d0ff91.jpg";